import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommunityBankService } from '@app/core/http';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-community-bank-initialize',
  templateUrl: './community-bank-initialize.component.html',
})
export class CommunityBankInitializeComponent implements OnInit, OnDestroy {
  constructor(
    private route: ActivatedRoute,
    public translate: TranslateService,
    private communityBankService: CommunityBankService,
    private router: Router
  ) {}

  ngOnInit() {
    this.translate.use('tr');
    sessionStorage.setItem('language', JSON.stringify('tr'));

    this.route.queryParams.subscribe((params: any) => {
      if (params.token) {
        if (params.cancelRedirectUrl) {
          localStorage.setItem('cancelRedirectUrl', params.cancelRedirectUrl);
        }
        const initialize = this.communityBankService.initialize(params.token);
        if (
          initialize.defaultPaymentMethod === 'PAPARAC' ||
          initialize.defaultPaymentMethod === 'PEPPARAC'
        ) {
          const swiftCode =
            initialize.defaultPaymentMethod === 'PAPARAC'
              ? 'PAPARA'
              : initialize.defaultPaymentMethod === 'PEPPARAC'
              ? 'PEPPARA'
              : '';
          this.router.navigate([`/community-banks/${swiftCode.toLowerCase()}`]);
        } else {
          this.router.navigate(['/community-banks']);
        }
      } else {
        this.router.navigate(['/community-banks']);
      }
    });
  }

  ngOnDestroy() {}
}
